import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(() => ({
    root: {
        width: '100%',
        flex: 1,
        minHeight: 0,
        maxHeight: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        flex: 1,
        minHeight: 0,
    },
}));
